import { render, staticRenderFns } from "./brainsSelector.vue?vue&type=template&id=1a4bb7da&scoped=true&"
import script from "./brainsSelector.vue?vue&type=script&lang=js&"
export * from "./brainsSelector.vue?vue&type=script&lang=js&"
import style0 from "./brainsSelector.vue?vue&type=style&index=0&id=1a4bb7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bb7da",
  null
  
)

export default component.exports